import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeScheduledReportsResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeScheduledReportsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeScheduledReportsSchema>
type Response = DataResponseWithPagination<
  z.infer<typeof BackofficeScheduledReportsResponseDataSchema>
>
type OnSuccessFn = (data: Response) => void

export const getBackofficeScheduledReportsQueryKey = (query?: Query) =>
  ["backofficeScheduledReports", query].filter((e) => e)

type Props = {
  query: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeScheduledReportsQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeScheduledReportsQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/scheduledReports", { params: query })
      onSuccess?.(data)
      return data.data
    },
  })
}
